import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { Map, List } from 'immutable';

import FormGroup from '../helpers/FormGroup';
import Select from '../helpers/Select';
import FieldError from '../helpers/FieldError';

/**
 * Stateless component for title category dropdown list.
 *
 * @param props {Object}.
 * @param props.dashboardUserTitles {Immutable.List} List of dashboard user titles (title categories).
 * @param props.formMode {string} Disabled state of control (view|edit).
 * @param props.formError {Immutable.Map} List of errors on form.
 * @param props.selectedUser {Immutable.Map} Current selected user.
 */
const UserDashboardTitleListComponent = ({ formMode, formError, selectedUser, dashboardUserTitles }) => {
  const error = formMode === 'edit' ? formError.get('dashboardUserTitleId', '') : '';
  const value = selectedUser.get('dashboardUserTitleId', '');

  return (
    <FormGroup className={error ? 'has-error' : ''}>
      <Select
        className="form-control"
        defaultText="Select Title Category..."
        disabled={formMode === 'view'}
        id="dashboardUserTitleSelect"
        label="Title Category"
        name="dashboardUserTitleId"
        nameKey="title"
        options={dashboardUserTitles}
        value={value}
        valueKey="id"
        showLabel
      />
      <FieldError message={error} />
    </FormGroup>
  );
};

UserDashboardTitleListComponent.propTypes = {
  dashboardUserTitles: PropTypes.instanceOf(List).isRequired,
  formError: PropTypes.instanceOf(Map).isRequired,
  formMode: PropTypes.string.isRequired,
  selectedUser: PropTypes.instanceOf(Map).isRequired,
};

export const UserDashboardTitleList = memo(UserDashboardTitleListComponent);
